var _path, _path2, _path3, _path4, _g, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefineListWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 80.0039C62.5914 80.0039 80.5 62.0953 80.5 40.0039C80.5 17.9125 62.5914 0.00390625 40.5 0.00390625C18.4086 0.00390625 0.5 17.9125 0.5 40.0039C0.5 62.0953 18.4086 80.0039 40.5 80.0039Z",
    fill: "#FDE8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.5 25L27.5 55L49.5 79C50.2141 79.0539 55.2731 77 56 77C67 71 74 64 79.5 49.5L53.5 25Z",
    fill: "#FF5555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.5 31.5L33 51.703L57 76.5C65.1628 72.6186 72.8894 65.775 76.5 57L49.5 31.5Z",
    fill: "#FF5555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 60.001C51.5457 60.001 60.5 51.0467 60.5 40.001C60.5 28.9553 51.5457 20.001 40.5 20.001C29.4543 20.001 20.5 28.9553 20.5 40.001C20.5 51.0467 29.4543 60.001 40.5 60.001Z",
    fill: "#F54F33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5 42L42.444 25L42 43.5884L53.5 55C58 51.5 59.7423 46.8263 60.5 42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 59.5C47 59.5 48.9133 58.2467 51 57L42.3012 48.7559L37.5879 53.4692L43.5 59.5Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6102 44.4463H38.2769L36.8869 27.7663C36.7369 25.9796 38.1502 24.4463 39.9436 24.4463C41.7369 24.4463 43.1502 25.9796 43.0002 27.7663L41.6102 44.4463Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9447 54.446C41.7856 54.446 43.278 52.9536 43.278 51.1126C43.278 49.2717 41.7856 47.7793 39.9447 47.7793C38.1037 47.7793 36.6113 49.2717 36.6113 51.1126C36.6113 52.9536 38.1037 54.446 39.9447 54.446Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefineListWarning);
export default __webpack_public_path__ + "static/media/refine_list_warning.bccb8e9b39b2dda15bdaee73248350a8.svg";
export { ForwardRef as ReactComponent };